(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    class VariantTitleBadge extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      document.forms[this.getAttribute('form')]?.addEventListener('variant:change', this.onVariantChange);
    }

    disconnectedCallback() {
      document.forms[this.getAttribute('form')]?.removeEventListener('variant:change', this.onVariantChange);
    }

    onVariantChange(event) {
      const variant = event.detail.variant;

      if (!variant || !variant.title) {
        this.hidden = true;
        return;
      }

      this.textContent = `(${variant.title})`;
      this.hidden = false;
    }
  }

  if (!customElements.get('variant-title-badge')) {
    customElements.define('variant-title-badge', VariantTitleBadge);
  }
  } catch(e) { console.error(e); }
})();

})();
